import Typography from "@atoms/Typography";
import { Autocomplete, Box, FormControl } from "@mui/material";
import React from "react";
import InputBase from "../InputBase";
import { TAutoCompleteBase } from "./type";

const AutocompleteBase: React.FC<TAutoCompleteBase> = ({
  options,
  onInputChange,
  width,
  label,
  optional,
  disabled,
  placeholder,
  value,
  ...inputBaseProps
}) => {
  return (
    <FormControl sx={{ width }}>
      {(label || optional) && (
        <Box sx={{ mb: 0.5 }} display="flex">
          <Typography variant="subtitle1" weight="medium">
            {label}
          </Typography>
          &nbsp;
          {optional && (
            <Typography variant="caption" color="general-mid">
              (optional)
            </Typography>
          )}
        </Box>
      )}
      <Autocomplete
        id="autoCompleteMyTens"
        value={value}
        renderOption={(props, option) => {
          return <li {...props} key={props.id}>{option}</li>;
        }}
        isOptionEqualToValue={(option, value) => {
          return option === value;
        }}
        getOptionLabel={(option) => option || ""}
        onInputChange={(_, newValue: string | null) => {
          onInputChange(newValue || "");
        }}
        options={options.map((option) => option.label)}
        renderInput={(params: any) => (
          <div ref={params.InputProps.ref}>
            <InputBase
              {...params}
              {...inputBaseProps}
              InputProps={{
                type: "search",
              }}
              disabled={disabled}
              placeholder={placeholder}
            />
          </div>
        )}
      />
    </FormControl>
  );
};

export default AutocompleteBase;
